import NotificationRow from './NotificationRow'
export default NotificationRow
